import { styled } from "theme/default/styled";
import { setFlexDF } from "theme/setter/setFlexValues/setFlexDF";

export const SSupportArticleContentHeader = styled.div`
  margin-bottom: 12px;
  gap: 24px;

  ${setFlexDF};
`;
